import React from 'react'
import classNames from 'classnames'
import styles from './Accounts.module.css'
import { getRole } from '../../../utils/getRole'

interface Props {
  isFixed: boolean
  onOpenPanel: () => void
  onOpenModal: () => void
}

const InvoicesMobileButtonsPanel: React.FC<Props> = React.memo(
  ({ isFixed, onOpenPanel, onOpenModal }) => {
    const { isClient } = getRole()
    return (
      <>
        {/* Невидимый placeholder для предотвращения отрыва кнопок от низа */}
        {isFixed && (
          <div
            style={{
              height: '35px',
              width: '100%',
              visibility: 'hidden',
              pointerEvents: 'none',
              marginBottom: '16px',
            }}
          />
        )}

        <div
          className={classNames(
            styles.invoicesButtonsPanel,
            'row',
            'd-flex',
            'd-md-none',
            {
              [styles.buttonsFixed]: isFixed,
              [styles.invoicesButtonsPanelDesktop]: !isFixed,
            }
          )}
        >
          <div className="col pr-2">
            <div
              onClick={onOpenPanel}
              className={classNames(
                styles.btn,
                styles.btnSmall2,
                styles.btnBlue,
                styles.btnWide,
                'mb-5'
              )}
            >
              К оплате
            </div>
          </div>
          {!isClient && (
            <div
              className={classNames('col-auto pl-2', {
                [styles.classMargin]: !isFixed,
              })}
            >
              <div
                onClick={onOpenModal}
                className={classNames(styles.btn, styles.btnSmall2, 'mb-2')}
              >
                + Груз
              </div>
            </div>
          )}
        </div>
      </>
    )
  }
)

InvoicesMobileButtonsPanel.displayName = 'InvoicesMobileButtonsPanel'

export default InvoicesMobileButtonsPanel
